import React from "react";
import {createUseStyles, useTheme} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {Theme} from "engage-client/theme";


const useStyles = createUseStyles<Theme>((theme) => ({
    gaugeContainer: {
        color: theme.accessoryPanel.dashBoard.sectionTitleColor,
        display: "flex",
        flexDirection: "column",
        padding: 32,
        [theme.breakpoints.only("lg")] : {
            padding: 20
        },
        [theme.breakpoints.only("xs")] : {
            padding: 20
        },
        background: theme.accessoryPanel.dashBoard.gauge.background,
        alignItems: "center",
        flex:1
    },
    title: {
        width: "100%",
        marginBottom: 38,
        [theme.breakpoints.down("lg")] : {
            marginBottom: 26
        },
        fontWeight: theme.accessoryPanel.dashBoard.simpleDashboard ? 700 : 400
    },
    gauge: {
        position: "relative",
        width: 180,
        height: 98,
    },
    gaugeQuadrants: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    },
    gaugeNeedle: {
        position: "absolute",
        width: 66,
        height: 28,
        transformOrigin: "56px 16px",
        transform: props => `rotate(${props.degrees}deg)`,
        bottom: -8,
        left: 34
    },
    levelText: {
        color: "white",
        marginTop: 14,
        marginBottom: 5
    },
    centerGauge: {
        marginTop: "auto",
        marginBottom: "auto"
    }

}));

export type GaugeProps = {
    level: number
    max: number
    position?: number
    players: number
}

function ordinalFor(position:number) {
    let ordinal = "th";
    if(position < 10 || position > 20) {
        let lastDigit = position % 10;
        if(lastDigit === 1) {
            ordinal = "st";
        } else if(lastDigit === 2) {
            ordinal = "nd";
        } else if (lastDigit === 3) {
            ordinal = "rd";
        }
    }
    return <sup>{ordinal}</sup>;
}

export default function Gauge({level,max,position, players}:GaugeProps) {
    const theme = useTheme<Theme>();
    const degrees = level / max * 180;
    const classes = useStyles({degrees});
    return (
        <div className={classes.gaugeContainer}>
            <DisplayText variant={TextVariant.s18reg} className={classes.title}>SCORE</DisplayText>
            <div className={classes.centerGauge}>
                <div className={classes.gauge}>
                    <img className={classes.gaugeQuadrants} src={theme.accessoryPanel.dashBoard.gauge.gaugeSVGPath} alt={`4 part gauge showing a min of 0 and max of ${max}`}/>
                    <img className={classes.gaugeNeedle} src={theme.accessoryPanel.dashBoard.gauge.needleSVGPath} alt={`Gauge needle pointing to ${level}`}/>
                </div>
                <DisplayText variant={TextVariant.s34reg} align="center" className={classes.levelText}>{level}</DisplayText>
                {position && <DisplayText variant={TextVariant.s18reg} align="center">{position}{ordinalFor(position)} of {players} participants</DisplayText>}
            </div>
        </div>
    );
}